export default {
  descriptionContent:
    "Upstream empowers customers to impact their community and strengthen the wellbeing of children and young people in Aotearoa. When you use a supplier through Upstream, this generates a portion of funding from the sale “we call an Upstream Contribution”.  We then provide these funds towards Upstream Good Causes that fit in to one of these areas",
  titleContent:
    "Upstream - Use quality businesses, generate funding for Good Causes",
  titleTag:
    "Upstream - Use quality businesses, generate funding for Good Causes",
};
